<template>
  <Vue-select
    class="custom-vue-select"
    v-model="selectedInternal"
    :options="data"
    label="name"
    placeholder="Escribir..."
    :reduce="data => data.id.toString()"
    :components="{Deselect}"
  >
  <template v-slot:no-options="{ data, searching }">
    <template v-if="searching">
      <em style="opacity: 0.5">No se encontraron resultados {{ data }}</em>
    </template>
    <em v-else style="opacity: 0.5">No se encuentraron resultados</em>
  </template>
  </Vue-select>
</template>

<script>
import { ref, watchEffect } from 'vue';

export default {
  props: {
    selectedYear: String,
  },
  setup(props, { emit }) {

    const data = ref([]);
    const selectedInternal = ref(null);

    const currentYear = new Date().getFullYear();
    const yearOptions = [];
    for (let year = currentYear; year >= currentYear - 50; year--) {
      yearOptions.push({ id: year, name: year });
    }
    data.value = yearOptions;

    watchEffect(() => {
      if (props.selectedYear) {
        const selectedOption = data.value.find(option => option.id === parseInt(props.selectedYear));
        selectedInternal.value = selectedOption;
      }
    });


    watchEffect(() => {
      if (selectedInternal.value !== null) {
        if (selectedInternal.value) {
          const selectedId = selectedInternal.value.id;

          const idAsString = selectedId ? selectedId.toString() : null;
          emit('update:selectedYear', selectedInternal.value);
          if (idAsString) {
            selectedInternal.value = idAsString;
            emit('update:selectedYear', idAsString);
          }
        }
      }
    });

    const Deselect = null;

    const getOptionKey = option => option.id.toString();

    return {
      selectedInternal,
      data,
      Deselect,
      getOptionKey
    };
  },
};
</script>
